import React, { useState } from 'react';

import TpDialog from '../shared/tp_dialog';
import { discard_guard_text } from '../shared/dialog_logic';
import { DialogFooter, ErrorBox, NoteField, RowContext } from './dialog_parts';
import { rupees } from './adapters';
import { ROW_ACTION, note_error } from './params';

/* Both only need the mandatory note. Props-only, shared with the session page. */
const COPY = {
  [ROW_ACTION.REVERT]: {
    title: 'Revert to the system value',
    submit: 'Revert',
    impact: (row) =>
      `Ops' changes to this penalty are dropped and the system works it out again from the session. If the session no longer earns a penalty, it disappears. ${row.teacher_name}'s month recalculates.`
  },
  [ROW_ACTION.REMOVE]: {
    title: 'Remove this penalty',
    submit: 'Remove penalty',
    impact: (row) =>
      `The ${rupees(row.charged)} charge comes off ${row.teacher_name}'s month. This cannot be undone; add the penalty again if needed.`
  }
};

const NoteActionModal = ({ action, row, saving, error, on_submit, on_close, on_focus_lost }) => {
  const [note, setNote] = useState('');
  const [touched, setTouched] = useState(false);
  const copy = COPY[action];
  const note_err = note_error(note);
  const server = (error && error.fields) || {};

  const submit = () => {
    setTouched(true);
    if (note_err) return;
    on_submit(note);
  };

  return (
    <TpDialog
      title_id="tp-pe-note-title"
      busy={saving}
      guard_text={discard_guard_text(note)}
      on_close={on_close}
      on_focus_lost={on_focus_lost}
    >
      <div className="tp-modal">
        <h4 id="tp-pe-note-title">{copy.title}</h4>
        <RowContext row={row} />
        <div className="tp-hint">{copy.impact(row)}</div>
        <NoteField
          id="tp-pe-note"
          label="Note (internal, required)"
          value={note}
          on_change={setNote}
          error_text={(touched && note_err) || server.note}
        />
        <ErrorBox error={error} />
        <DialogFooter
          saving={saving}
          error={error}
          submit_label={copy.submit}
          danger={action === ROW_ACTION.REMOVE}
          on_submit={submit}
          on_confirm={submit}
          on_close={on_close}
        />
      </div>
    </TpDialog>
  );
};

export default NoteActionModal;
